//https://blog.logrocket.com/simplify-react-state-management-with-hookstate/
import { hookstate } from '@hookstate/core'

const globalDistrictStore = hookstate({
    IsActive: true
});

export default globalDistrictStore;